function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";
import { currencyToIndianRsWord } from "../../../utils";

// const locations = [
//   { id: 1, lat: 22.520240438595458, lng: 88.34836542606354 },
//   { id: 2, lat: 21.17254999753366, lng: 83.43662549289871 },
//   { id: 3, lat: 22.796990585243496, lng: 82.92750706741614 },
//   { id: 4, lat: 22.60604796004955, lng:71.8679249175013 },
// ];
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var GMaps = function GMaps(_ref) {
  var locations = _ref.locations,
    viewMapHandler = _ref.viewMapHandler,
    activeMarker = _ref.activeMarker,
    config = _ref.config,
    appType = _ref.appType;
  var _useJsApiLoader = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: "AIzaSyD8g5LLt4YxRR363AOmHEZhGHaUctJIz4Q"
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    map = _useState2[0],
    setMap = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProject = _useState4[0],
    setSelectedProject = _useState4[1];
  useEffect(function () {
    if (map && activeMarker) {
      var selectedLocation = locations.find(function (location) {
        return location.id === activeMarker;
      });
      if (selectedLocation) {
        map.setCenter({
          lat: parseFloat(selectedLocation.lat),
          lng: parseFloat(selectedLocation.lng)
        });
        map.setZoom(16);
      }
    }
  }, [map, activeMarker, locations]);
  useEffect(function () {
    var formattedLocations = locations.map(function (location) {
      return _objectSpread(_objectSpread({}, location), {}, {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng)
      });
    });
    if (isLoaded && formattedLocations.length > 0) {
      var bounds = new window.google.maps.LatLngBounds();
      formattedLocations.forEach(function (location) {
        var lat = parseFloat(location.lat);
        var lng = parseFloat(location.lng);
        if (!isNaN(lat) && !isNaN(lng) && (lat !== 0 || lng !== 0)) {
          bounds.extend({
            lat: lat,
            lng: lng
          });
        }
      });
      if (map) {
        map.fitBounds(bounds);
      }
    }
  }, [isLoaded, locations, map]);
  var onLoad = useCallback(function (map) {
    setMap(map);
  }, [locations]);
  var onUnmount = useCallback(function () {
    setMap(null);
  }, []);
  var handleProjectClick = function handleProjectClick(project) {
    setSelectedProject(project);
  };
  var currencyFormating = function currencyFormating(price) {
    if (price >= 10000000) return currencyToIndianRsWord.format(price).slice(0, -2).concat(" Cr*");
    return currencyToIndianRsWord.format(price).slice(0, -1).concat(" L");
  };
  var filteredLocations = locations.filter(function (location) {
    var lat = parseFloat(location.lat);
    var lng = parseFloat(location.lng);
    return lat !== 0 && lng !== 0;
  });
  return isLoaded ? /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(GoogleMap, {
      mapContainerStyle: {
        width: "45vw",
        height: "100vh"
      },
      center: selectedProject ? selectedProject : filteredLocations.length > 0 ? {
        lat: filteredLocations[0].lat,
        lng: filteredLocations[0].lng
      } : {
        lat: 0,
        lng: 0
      },
      zoom: selectedProject ? 24 : 18,
      onLoad: onLoad,
      onUnmount: onUnmount,
      children: filteredLocations.map(function (location) {
        var lat = parseFloat(location.lat);
        var lng = parseFloat(location.lng);
        if (lat !== 0 && lng !== 0) {
          return /*#__PURE__*/_jsx(Marker, {
            position: {
              lat: lat,
              lng: lng
            },
            onClick: function onClick() {
              handleProjectClick(location);
              viewMapHandler(location.id);
            },
            children: /*#__PURE__*/_jsx(InfoWindow, {
              position: {
                lat: lat,
                lng: lng
              },
              onCloseClick: function onCloseClick() {
                return setSelectedProject(null);
              },
              children: /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  handleProjectClick(location);
                  viewMapHandler(location.id);
                },
                className: "select-none cursor-pointer ",
                children: [/*#__PURE__*/_jsxs("h2", {
                  className: "".concat(config.fontBody, " font-semibold uppercase md:text-[11px]"),
                  children: [location.name, " ", "(".concat(location.city, ")")]
                }), /*#__PURE__*/_jsxs("p", {
                  className: "".concat(config.fontTitle, " pt-1 text-center font-semibold md:text-[11px]"),
                  children: ["STARTING:", /*#__PURE__*/_jsxs("span", {
                    className: "md:text-[12px]",
                    children: [" ", currencyFormating(location.price)]
                  })]
                })]
              })
            })
          }, location.id)
          // options={{
          //   animation: activeMarker === location.id ? window.google.maps.Animation.BOUNCE : null,
          // }}
;
        } else {
          return null;
        }
      })
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
export default GMaps;